import { useEffect } from 'react'
import { useMonthCloseNavStore } from '@/store/monthCloseNavStore'

/**
 * Seeds month-close left-nav warning counts from the daily nav-status snapshot.
 * Mounted once from App; no interval so live page counts are not clobbered.
 */
export function useMonthCloseNavStatusPoller() {
  const fetchNavStatus = useMonthCloseNavStore((s) => s.fetchNavStatus)

  useEffect(() => {
    void fetchNavStatus()
  }, [fetchNavStatus])
}
